const isEmptyObject = (obj:Object) => obj ? !!Object?.values(obj)?.find(el => el !== null && el !== '' && el !== false) : null;

export default isEmptyObject;
